import api from "../../../shared/api/client";

export async function getProducts() {
  const { data } = await api.get("/product-options");
  return data;
}

export async function getManufacturers() {
  const { data } = await api.get("/manufacturer");
  return data;
}

export async function getManufacturersList() {
  const { data } = await api.get("/manufacturers");
  return data;
}

export async function getGoodsGroups() {
  const { data } = await api.get("/goodsgroup");
  return data;
}

export async function getJobs() {
  const { data } = await api.get("/job");
  return data;
}

export async function getDcs() {
  const { data } = await api.get("/dcs");
  return data;
}

export async function getDealerCategories() {
  const { data } = await api.get("/dealer-categories");
  return data;
}

export async function getTargetGroups() {
  const { data } = await api.get("/targetgroups");
  return data;
}

export async function getSaleoffices() {
  const { data } = await api.get("/saleoffices");
  return data;
}
